// The "version" URL parameter will force either version A or version B 
// https://www.zymoresearch.com?version=a will force version A
// https://www.zymoresearch.com?version=b will force version B
// https://www.zymoresearch.com?version=reset will remove the forced version
if (window.location.href.indexOf("version") > -1) {
    let url = new URL(window.location.href);
    let version = url.searchParams.get('version');
    if (version === "a") {
        localStorage.setItem("forcedVersion", "a");
    } else if (version === "b") {
        localStorage.setItem("forcedVersion", "b")
    } else if (version === "reset") {
        localStorage.removeItem("forcedVersion");
    }
}

const forcedVersion = localStorage.getItem("forcedVersion");

// If the user's segmentationDigit is part of the abSegmentationString metafield, version B will be displayed
// Otherwise, the user will default to Version A

let version = "a";
let segmentationDigit = null; 

if (forcedVersion) {
    version = forcedVersion;
} else {

    if (!localStorage.getItem("segmentationDigit")) {
        segmentationDigit = localStorage.setItem("segmentationDigit", Number(Date.now().toString().slice(-1)));
    } else {
        segmentationDigit = localStorage.getItem("segmentationDigit");
    }
    if (segmentationDigit && abSegmentationArray.includes(segmentationDigit)) {
        version = "b";
    }
}

displayVersion(version)
window.hj('identify', userId, {
    "user_version": version
})

function displayVersion(version) {
    if (version === "a") {
        for (let i = 0; i < document.getElementsByClassName("version-b").length; i++) {
            document.getElementsByClassName("version-a")[i].classList.remove("d-none");
        }
    } else if (version === "b") {
        for (let i = 0; i < document.getElementsByClassName("version-a").length; i++) {
            document.getElementsByClassName("version-b")[i].classList.remove("d-none");
        }
    }
} 
